(($) => {
  const originalMediaElementPlayer = $.fn.mediaelementplayer;
  $.fn.mediaelementplayer = function (options) {
    this.each(function () {
      const video = $(this);
      if (video.parents('.transparent-video').length
        && (mp4Source = video.find('source[type="video/mp4"]'))
      ) {
        mp4Source.attr('type', 'video/mp4; codecs="hvc1"');
      }
    });
    return originalMediaElementPlayer.apply(this, arguments);
  };
})(jQuery);